import type { Buffer } from "../model/buffer";
import { isBlankLine, lastLineIndex } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";

function paragraphBackwardOnce(buffer: Buffer, line: number): number {
  let target = line - 1;
  while (target > 0 && !isBlankLine(buffer, target)) {
    target -= 1;
  }
  return Math.max(target, 0);
}

function paragraphForwardOnce(buffer: Buffer, line: number): number {
  const last = lastLineIndex(buffer);
  let target = line + 1;
  while (target < last && !isBlankLine(buffer, target)) {
    target += 1;
  }
  return Math.min(target, last);
}

/** `{`: 前の空行、または無ければバッファ先頭へ移動する。exclusive。 */
export function paragraphBackward(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  let line = cursor.line;
  const times = Math.max(count ?? 1, 1);
  for (let i = 0; i < times; i += 1) {
    line = paragraphBackwardOnce(buffer, line);
  }
  return { start: cursor, end: { line, col: 0 }, kind: "exclusive" };
}

/** `}`: 次の空行、または無ければバッファ末尾へ移動する。exclusive。 */
export function paragraphForward(buffer: Buffer, cursor: Cursor, count: number | null): Range {
  let line = cursor.line;
  const times = Math.max(count ?? 1, 1);
  for (let i = 0; i < times; i += 1) {
    line = paragraphForwardOnce(buffer, line);
  }
  return { start: cursor, end: { line, col: 0 }, kind: "exclusive" };
}
